import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';

const GroupSubCategory = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const groupSubCategoriesApi = useMutation(() => axios.get(endPoints.myIdm.groupSubCategories));

    const currentValue = index !== undefined ? order?.multipleResourceGroups?.[index]?.groupSubCategory : order?.groupSubCategory;

    const setGroupSubCategory = (groupSubCategory, groupSubCategoryDetails) => {
        const updatedGroups = [...(order?.multipleResourceGroups || [])];
        updatedGroups[index] = {
            ...updatedGroups[index],
            groupSubCategory,
            groupSubCategoryDetails,
        };
        setOrder({
            ...order,
            multipleResourceGroups: updatedGroups,
        });
    };

    const handleOnSelectChange = (selected) => {
        setGroupSubCategory(selected.value, selected);
    };

    const resetOptions = () => {
        setOptions([]);
    };
    React.useEffect(() => {
        if (groupSubCategoriesApi?.isSuccess) {
            setOptions(
                (groupSubCategoriesApi?.data?.data || [])?.map((subCategory) => ({
                    label: subCategory?.groupSubCategoryDisplayName,
                    value: subCategory?.groupSubCategoryBackendName,
                    backendName: subCategory?.groupSubCategoryBackendName,
                    data: subCategory,
                }))
            );
        }
    }, [groupSubCategoriesApi?.isSuccess]);

    React.useEffect(() => {
        resetOptions();
        groupSubCategoriesApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [currentValue, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <Select
                sx={{ marginTop: 0 }}
                key={`group-sub-category-${index !== undefined ? index : 'single'}`}
                label="Group Sub Category *"
                value={options.find((option) => option.value === currentValue) || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
                disabled={groupSubCategoriesApi.isLoading}
                isLoading={groupSubCategoriesApi.isLoading}
                isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            />
        </Stack>
    );
};

GroupSubCategory.propTypes = {
    index: PropTypes.number,
};

GroupSubCategory.defaultProps = {
    index: undefined,
};

export default GroupSubCategory;
